import { TariffCategory } from '../../shared/models/types'
import { WallboxDto } from '../../wallboxes/api/dto/wallbox.dto'
import { MOCK_WALLBOX_NAME, MOCK_WALLBOX_NAME_2, MOCK_WALLBOX_ID, MOCK_CURRENCY, MOCK_ENERGY_TYPE } from './mock-properties'

export const MOCK_WALLBOXES: WallboxDto[] = [
  {
    wallboxId: '00141648D8DA6B01',
    wallboxName: MOCK_WALLBOX_NAME,
    wallboxType: 5,
    activeTariff: {
      elements: [],
      tariff: {
        id: MOCK_WALLBOX_ID,
        currency: MOCK_CURRENCY,
        type: null,
        elements: [
          {
            restrictions: null,
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0.22,
                vat: 19,
                step_size: 1,
              },
            ],
          },
        ],
        country_code: 'DE',
        party_id: 'HGE',
        tariff_alt_text: null,
        tariff_alt_url: null,
        min_price: null,
        max_price: null,
        start_date_time: '2023-08-21T22:00:00',
        end_date_time: null,
        energy_mix: null,
        last_updated: '2025-06-19T07:29:41',
      },
      category: TariffCategory.staticTariff,
      dischargePrice: null,
      name: 'Tariff 1',
    },
    inactiveTariffs: [],
    expiredTariffs: [],
    useMidMeter: false,
    pulseWeight: 0,
  },
  {
    wallboxId: '00141648D8DA6A11',
    wallboxName: MOCK_WALLBOX_NAME_2,
    wallboxType: 5,
    activeTariff: {
      elements: [],
      tariff: {
        id: MOCK_WALLBOX_ID,
        currency: MOCK_CURRENCY,
        type: null,
        elements: [
          {
            restrictions: null,
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0.22,
                vat: 19,
                step_size: 1,
              },
            ],
          },
        ],
        country_code: 'DE',
        party_id: 'HGE',
        tariff_alt_text: null,
        tariff_alt_url: null,
        min_price: null,
        max_price: null,
        start_date_time: '2023-08-21T22:00:00',
        end_date_time: null,
        energy_mix: null,
        last_updated: '2025-06-19T07:29:41',
      },
      category: TariffCategory.staticTariff,
      dischargePrice: null,
      name: 'Tariff 1',
    },
    inactiveTariffs: [],
    expiredTariffs: [],
    useMidMeter: false,
    pulseWeight: 0,
  },
]
